import { callEndpoint } from './apiUtils';
import 'whatwg-fetch';

export const refreshChatTokenApi = async (jwt: string, userArn: string) => {
  const {
    APPINSTANCEUSERARN,
    ACCESSKEYID,
    SECRETACCESSKEY,
    SESSIONTOKEN,
    EXPIRATION,
    CHANNELARN,
  }: JoinChatSuccessResponse = await callEndpoint(
    `refresh-chat-token?userArn=${encodeURIComponent(userArn)}`,
    jwt,
    'POST'
  );

  return {
    APPINSTANCEUSERARN,
    ACCESSKEYID,
    SECRETACCESSKEY,
    SESSIONTOKEN,
    EXPIRATION,
    CHANNELARN,
  } as JoinChatSuccessResponse;
};
